import React, {PropsWithChildren} from 'react';
import {Navigate} from 'react-router-dom';
import {useFirebaseAuthUserStore} from '../stores/FirebaseAuthUserStore';

export const Protected = ({children}: PropsWithChildren) => {
	// Zustand
	const firebaseAuthUser = useFirebaseAuthUserStore(
		(state) => state.firebaseAuthUser,
	);

	if (!firebaseAuthUser) {
		return <Navigate to="/" />;
	}

	return <>{children}</>;
};
